import React from 'react';
import First from './Sections/First';
import Second from './Sections/Second';
import Third from './Sections/Third';
// import Four from './Sections/Four';
// import Five from './Sections/Five';
import Six from './Sections/Six';

const Main = () => {
    return (
        <main>
            <First />
            <Second />
            <Third />
            {/*<Four />*/}
            {/*<Five />*/}
            <Six />
        </main>
    );
};

export default Main;